<app-page *ngIf="vo$ | async; let vo">
	<app-page-header>
		<app-breadcrumb [paths]="paths"></app-breadcrumb>
	</app-page-header>
	<app-page-actions>
		<app-button *ngIf="vo.published.status !== PublicationStatus.Unpublished"
								(click)="goToSimulationRoute()"
								id="{{ cmpId + 'simulate' }}"
								class="app-exposition-view__test-api-btn"
								[leftIcon]="DcIcons.TestApi"
								i18n="@@expositions.marketplace.test-api">
			simulate
		</app-button>
		<button
			*ngIf="vo.canDelete"
			mat-icon-button
			class="app-exposition-view__action-btn"
			[matMenuTriggerFor]="actions"
			id="exposition-menu-btn">
			<mat-icon [svgIcon]="DcIcons.MenuMoreOptionsHandle"></mat-icon>
		</button>
		<mat-menu #actions="matMenu">
			<ng-template matMenuContent>
				<button
					*ngIf="vo.canDelete"
					id="{{ cmpId }}-delete-btn"
					(click)="openDeleteConfirmationPopup()"
					class="app-exposition-view__delete-btn"
					mat-menu-item>
					<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
					<span i18n="@@general.action.delete">delete</span>
				</button>
				<button *ngIf="true" id="{{ cmpId }}-help-nav" mat-menu-item>
					<app-nav-doc [navigateToUrl]="FunctionalDocumentationKeys.EXPOSITION">
						<span i18n="@@general.action.help">help</span>
					</app-nav-doc>
				</button>
			</ng-template>
		</mat-menu>
	</app-page-actions>

	<app-page-content>
		<div class="app-exposition-view">
			<section class="app-exposition-view__metadata-api">
				<!--	Exposition Element Metadata			-->
				<app-deprec-outline class="app-exposition-view__metadata">
					<div card-outline-title
						class="app-exposition-view__metadata-label"
						[matTooltip]="vo.metadata.label"
						[matTooltipDisabled]="vo.metadata.label.length <= Configuration.maxLengthExpoMetadataTitleDisplay"
						matTooltipPosition="right">
						{{ vo.metadata.label | truncate: Configuration.maxLengthExpoMetadataTitleDisplay : 1 : 'end' }}
					</div>
					<button
						card-outline-btns
						mat-icon-button
						class="app-exposition-view__action-btn"
						(click)="editMetadata()">
						<mat-icon [svgIcon]="DcIcons.Edit"></mat-icon>
					</button>
					<app-exposition-internal-metadata-config
						card-outline-content
						[expositionMetadata]="vo.metadata"
						[isInViewMode]="true"></app-exposition-internal-metadata-config>
				</app-deprec-outline>

				<!--	Publication API			-->
				<app-deprec-outline class="app-exposition-view__api">
					<div card-outline-title class="app-exposition-view__api-header">
						<span i18n="@@expositions.publication.api">api publication</span>
						<app-exposition-publication-status *ngIf="vo.published.status !== PublicationStatus.Running && vo.actionInProgress === 'none'"
							[status]="
								vo.published.status
							"></app-exposition-publication-status>
					</div>

					<div
						*ngIf="vo.canEdit"
						card-outline-btns
						class="app-exposition-view__api__btns">
						<ng-container *ngIf="(vo.published.status === PublicationStatus.Unpublished || vo.published.status === PublicationStatus.Error)
								&& vo.actionInProgress !== 'in-progress'">
							<button id="{{ cmpId }}-publish-btn"
											mat-raised-button
											color="primary"
											class="app-exposition-view__api__publish-btn"
											matTooltip="Un accès actif est obligatoire pour publier l’API"
											i18n-matTooltip="@@expositions.publication.api.tooltip.activeAccess"
											[matTooltipDisabled]="vo.published.hasActiveAccess"
											[disabled]="vo.actionInProgress === 'publish'"
											(click)="openPublishConfirmationPopup()">
							<span class="app-exposition-view__api__spinner">
								<mat-spinner data-style-override
									*ngIf="vo.actionInProgress === 'publish'"
									[diameter]="20"></mat-spinner>
								<span i18n="@@expositions.publication.api.action.publish">
									publish
								</span>
							</span>
							</button>
						</ng-container>

						<ng-container
							*ngIf="vo.published.status !== PublicationStatus.Unpublished && vo.published.status !== PublicationStatus.Error &&
							vo.published.status !== PublicationStatus.Running">
							<button
								class="action-btn"
								color="primary"
								id="{{ cmpId }}-update-data-btn"
								mat-icon-button
								matTooltip="update data"
								i18n-matTooltip="
									@@expositions.publication.api.action.updateData"
								[disabled]="vo.actionInProgress !== 'none'"
								(click)="openUpdateDataConfirmationPopup()">
								<mat-icon *ngIf="vo.actionInProgress === 'update-data'">
									<mat-spinner [diameter]="20"></mat-spinner>
								</mat-icon>
								<mat-icon
									*ngIf="vo.actionInProgress !== 'update-data'"
									[svgIcon]="DcIcons.Input"></mat-icon>
							</button>
							<button
								class="action-btn"
								color="primary"
								id="{{ cmpId }}-update-btn"
								mat-icon-button
								matTooltip="update"
								i18n-matTooltip="@@expositions.publication.api.action.update"
								[disabled]="vo.actionInProgress !== 'none'"
								(click)="openUpdateConfirmationPopup()">
								<mat-icon *ngIf="vo.actionInProgress === 'update'">
									<mat-spinner [diameter]="20"></mat-spinner>
								</mat-icon>
								<mat-icon
									*ngIf="vo.actionInProgress !== 'update'"
									[svgIcon]="DcIcons.Settings"></mat-icon>
							</button>
							<button
								class="action-btn"
								color="primary"
								*ngIf="vo.published.status === PublicationStatus.Unavailable"
								id="{{ cmpId }}-activate-btn"
								mat-icon-button
								matTooltip="activate"
								i18n-matTooltip="@@expositions.publication.api.action.activate"
								[disabled]="vo.actionInProgress !== 'none'"
								(click)="openActivateConfirmationPopup()">
								<mat-icon *ngIf="vo.actionInProgress === 'activate'">
									<mat-spinner [diameter]="20"></mat-spinner>
								</mat-icon>
								<mat-icon
									*ngIf="vo.actionInProgress !== 'activate'"
									[svgIcon]="DcIcons.Share"></mat-icon>
							</button>
							<button
								class="action-btn"
								color="primary"
								*ngIf="vo.published.status === PublicationStatus.Available"
								id="{{ cmpId }}-deactivate-btn"
								mat-icon-button
								matTooltip="deactivate"
								i18n-matTooltip="
									@@expositions.publication.api.action.deactivate"
								[disabled]="vo.actionInProgress !== 'none'"
								(click)="openDeactivateConfirmationPopup()">
								<mat-icon *ngIf="vo.actionInProgress === 'deactivate'">
									<mat-spinner [diameter]="20"></mat-spinner>
								</mat-icon>
								<mat-icon
									*ngIf="vo.actionInProgress !== 'deactivate'"
									[svgIcon]="DcIcons.ShareOff"></mat-icon>
							</button>
							<button
								class="action-btn delete-data"
								color="primary"
								id="{{ cmpId }}-clear-data-btn"
								mat-icon-button
								matTooltip="clear data"
								i18n-matTooltip="@@expositions.publication.api.action.clear"
								[disabled]="vo.actionInProgress !== 'none'"
								(click)="openClearDataConfirmationPopup()">
								<mat-icon *ngIf="vo.actionInProgress === 'clear-data'">
									<mat-spinner [diameter]="20"></mat-spinner>
								</mat-icon>
								<mat-icon
									*ngIf="vo.actionInProgress !== 'clear-data'"
									[svgIcon]="DcIcons.Output"></mat-icon>
							</button>
						</ng-container>
					</div>

					<app-published-exposition
						[published]="vo.published"
						card-outline-content></app-published-exposition>
				</app-deprec-outline>
			</section>

			<section class="app-exposition-view__parameters">
				<!--	Exposition Endpoint Metadata			-->
				<app-panel
					prefix="e2e"
					headerHeight="3rem"
					initialState="true"
					[isAlwaysOpen]="false"
					[actions]="publicMetadataActions">
					<div panel-title class="app-panel__title">
						<mat-icon [svgIcon]="ComponentIcons.PublicEndpointMetadata"></mat-icon>
						<span i18n="@@exposition.metadata.public">Metadata</span>
					</div>
					<app-exposition-endpoint-metadata-config
						[expositionMetadata]="vo.endpointMetadata"
						[isInViewMode]="true"></app-exposition-endpoint-metadata-config>
				</app-panel>

				<!--	Column List Configuration			-->
				<app-panel
					prefix="e2e2"
					class="app-card-outline__columns"
					headerHeight="3rem"
					isAlwaysOpen="true"
					hasSearchableGrid="true"
					[itemsCount]="vo.columns.elements.size"
					[actions]="columnsActions"
					(search)="columnsGrid.search($event)">
					<div panel-title class="app-panel__title">
						<mat-icon [svgIcon]="ComponentIcons.Column"></mat-icon>
						<span i18n="@@exposition.access.list.column.columns">columns</span>
					</div>
					<app-exposition-columns-config
						#columnsGrid="ColumnsGrid"
						[columnConfigList]="vo.columns"
						[isInViewMode]="true"></app-exposition-columns-config>
				</app-panel>

				<!--	Access List Configuration			-->
				<app-panel
					headerHeight="3rem"
					class="app-card-outline__access-list"
					isAlwaysOpen="true"
					hasSearchableGrid="true"
					[itemsCount]="vo.accessPoints.elements.size"
					[actions]="accessListActions"
					(search)="accessPointsGrid.search($event)">
					<div panel-title class="app-panel__title">
						<mat-icon [svgIcon]="ComponentIcons.Access"></mat-icon>
						<span i18n="@@exposition.access.list.title">access</span>
					</div>
					<app-exposition-access-list
						#accessPointsGrid="AccessPointsGrid"
						[expositionAccessList]="vo.accessPoints"
						(editAccess)="goToAccessConfig($event)"
						(toggleAccessStatus)="toggleAccessStatus($event)"
						(deleteAccess)="deleteAccess($event)"></app-exposition-access-list>
				</app-panel>
			</section>
		</div>
	</app-page-content>
</app-page>
